import { Box } from '@chakra-ui/react';
import { Asset, VideoSlideItemType } from '@llx/common';

import { getAssetByRefOrThrow } from '@/pages/caseCluster/utils/getAssetByRef';
import { MotionBox } from '@/ui/Motion/MotionBox';
import APP_CONSTANTS from '@/utils/constants/app.constants';

type Props = {
  item: VideoSlideItemType;
  assets: Asset[];
};

function VideoItem({ item, assets }: Props) {
  const videoUrl = getAssetByRefOrThrow(item.assetRef, assets).url;

  return (
    <MotionBox
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{
        opacity: 1,
        scale: 1,
        transition: APP_CONSTANTS.SHOW_ANIMATIONS
          ? { duration: 0.7, delay: 0.2, ease: 'easeOut' }
          : { duration: 0 },
      }}
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
      maxW="40%"
      maxH="50%"
      aspectRatio={16 / 9}
      borderRadius="md"
      overflow="hidden"
    >
      <Box
        as="video"
        src={videoUrl}
        controls
        autoPlay
        muted={false}
        loop={false}
        sx={{
          display: 'block',
          height: 'auto',
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </MotionBox>
  );
}

export default VideoItem;
